import apiClient from '@/shared/api/client';
import type { UserProfile } from '@/app/model/Store';

export interface LoginPayload {
  username: string;
  password: string;
}

export interface RegisterPayload {
  username?: string;
  email?: string;
  password?: string;
  password_repeat?: string;
  [key: string]: unknown;
}

export interface ReferralPayload {
  agent_id: string;
}

export interface UpdatePasswordPayload {
  old_password: string;
  new_password: string;
  new_password_repeat?: string;
}

export interface ResetPasswordPayload {
  email: string;
}

export type UpdateProfilePayload = Partial<UserProfile>;

export interface UserStatsParams {
  period?: string;
  start_date?: string;
  end_date?: string;
}

export default class AuthService {
  static async login(username: string, password: string) {
    return apiClient.post('/auth/token/', {
      username: username,
      password: password,
    });
  }
  static async logout() {
    return apiClient.post('/auth/logout/');
  }
  static async register(data: RegisterPayload) {
    return apiClient.post('/auth/user/', data);
  }
  static async createReferral(data: ReferralPayload) {
    return apiClient.post('/increment-referral-click/', data);
  }
  static async getProfile() {
    return apiClient.get('/auth/user-data/');
  }
  static async getUserStats(params: UserStatsParams | null) {
    return apiClient.get('/auth/exchange-stats/', { params });
  }
  static async updateProfile(data: UpdateProfilePayload) {
    return apiClient.put('/auth/user-data/', data);
  }
  static async updatePassword(data: UpdatePasswordPayload) {
    return apiClient.post('/auth/change-password/', data);
  }
  static async resetPassword(data: ResetPasswordPayload) {
    return apiClient.post('/auth/password-reset/', data);
  }
  static async draftBalance() {
    return apiClient.post('/auth/create-balance-order/');
  }
  static async downloadUserExchanges() {
    return apiClient.get('/auth/download-exchanges/', {
      responseType: 'blob',
    });
  }
}
